const phoneRegex = /^\+(?:[0-9] ?){6,14}[0-9]$/;

export const validatePhoneNumber = (phoneNumber: string): boolean => {
  return phoneRegex.test(phoneNumber);
};
